import { navigate } from "lib/routes/navigate"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"

export function navigateProject(projectId) {
    navigate(`/authoring/projects/${projectId}`)
}

export function navigateProjects() {
    navigate("/authoring/projects")
}

export function navigateScheduleLibrary(projectId, groupId) {
    navigate(`/authoring/projects/${projectId}/${groupId}/correlator`)
}

export function navigateScheduleDetails({ projectId, groupId, scheduleId }) {
    navigate(`/authoring/projects/${projectId}/${groupId}/correlator/${scheduleId}`)
}

export function navigateSimilarTasks({ projectId, scheduleId, originalTaskId, groupId }) {
    navigate(`/authoring/projects/${projectId}/${groupId}/correlator/${scheduleId}/${originalTaskId}/similar`)
}

export function navigateTaskEditor({ projectId, scheduleId, originalTaskId, groupId }) {
    navigate(`/authoring/projects/${projectId}/${groupId}/correlator/${scheduleId}/${originalTaskId}/edit`)
}

export function navigateComponentSimilarity({ projectId, groupId, componentId, componentVersion }) {
    navigate(`/authoring/projects/${projectId}/${groupId}/component-similar/${componentId}/${componentVersion}`)
}

export function navigateGroup({ projectId, groupId }) {
    navigate(`/authoring/projects/${projectId}/${groupId}`)
}

export function navigateAddTask({ projectId, groupId }) {
    navigate(`/authoring/projects/${projectId}/${groupId}/add-task`)
}

export function navigateSchedulePreview({ projectId, scheduleId }) {
    navigate(`/authoring/projects/${projectId}/schedule-editor/${scheduleId}/preview`)
}
export function navigateScheduleEditor({ projectId, scheduleId, openAmend }) {
    const params = openAmend ? `?openAmend=${encodeURIComponent(openAmend)}` : ""
    navigate(`/authoring/projects/${projectId}/schedule-editor/${scheduleId}${params}`)
}
export function navigateScheduleCommentary({ projectId, scheduleId }) {
    navigate(`/authoring/projects/${projectId}/schedule-editor/${scheduleId}/commentary`)
}
export function navigateCompareView({ destination, source, projectId }) {
    navigate(`/authoring/schedules/compare/${destination}/${source}/${projectId}`)
}

export function navigateSubmitReview({ projectId, scheduleId }) {
    navigate(`/authoring/projects/${projectId}/${scheduleId}/review`)
}

export function navigateSequentialReview({ projectId, scheduleId, approved = 0, rejected = 0 }) {
    navigate(
        `/authoring/projects/${projectId}/${scheduleId}/review?sequential=true&approved=${approved}&rejected=${rejected}`
    )
}

export function openProjectSchedule({ projectId, scheduleId, status, canAccessReview }) {
    if (shouldOpenReview({ status, canAccessReview })) {
        navigateSubmitReview({ projectId, scheduleId })
        return
    }

    navigateSchedulePreview({ projectId, scheduleId })
}

function shouldOpenReview({ status, canAccessReview }) {
    return status === DraftStatus.SUBMITTED && canAccessReview
}
